import React from "react";
import Image from "react-bootstrap/Image";
import Banner_final from "./Banner_final.jpg";

const Bienvenue = () => {
  return (
    <div>
      <div className="container-fluid px-0">
        <div className="row mx-0 px-0">
          <div className="col mx-0 px-0">
            <Image
              src={Banner_final}
              fluid
              alt="Bannière d'accueil du Bureau National des Examens d'État"
            />
          </div>
        </div>
      </div>

      <div className="container mt-4 mb-5">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-4 mb-md-0">
            <h2 className="mb-3">Présentation du BUNEXE</h2>
            <p className="text-justify">
              Le Bureau National des Examens d’État (<strong>BUNEXE</strong>)
              est une direction du Ministère de l’Éducation Nationale et de la
              Formation Professionnelle (<strong>MENFP</strong>) qui planifie,
              coordonne et participe à l’exécution de toutes les activités
              englobant les examens d’État sur tout le territoire national.
              Composé de plusieurs entités comme le Service de Contrôle
              Administratif et Financier (<strong>SCAF</strong>), le Service
              d’Organisation des Examens d’État (<strong>SOEE</strong>), l’Unité
              Informatique (<strong>UI</strong>) et le Service de Certification
              et d’Équivalence (<strong>SCE</strong>), il est la plaque
              tournante du MENFP en matière d’activités de préparation et
              d'organisation des examens officiels.
            </p>
            <p className="text-justify">
              Il procède à la certification des apprenants du système éducatif
              haïtien et à l’homologation des certificats et diplômes
              (circulaire ministérielle du 8 Décembre 1993), établit le plan
              d’organisation des examens d’État avec l’accompagnement des
              directions techniques du MENFP (<strong>DES, DFP, DEF</strong>),
              et encadre techniquement via les BUDEXE (Bureau Départemental
              d’Examen d’État) les Directions Départementales d’Éducation (DDE)
              dans le cadre des évaluations de la 9<sup>e</sup> AF, de la
              Terminale et d’autres examens nationaux.
            </p>
          </div>

          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <h2 className="mb-3">Projet d'informatisation</h2>
            <p className="text-justify">
              Le projet d’informatisation des processus liés à la gestion du
              baccalauréat haïtien s’inscrit, entre autres, dans un vaste plan
              de réforme et de modernisation de plusieurs structures du
              Ministère de l’Éducation Nationale et de la Formation
              Professionnelle (<strong>MENFP</strong>), en particulier le Bureau
              National des Examens d’État (BUNEXE) et les Bureaux Départementaux
              des Examens d’État (<strong>BUDEXE</strong>).
            </p>
            <p className="text-justify">
              Cette réforme permet de réviser et d'améliorer l'ensemble des
              processus liés aux examens d'État. Elle offre aux Directions
              Départementales d'Éducation l'accès à une plateforme unique pour
              la gestion centralisée des inscriptions aux examens d'État à tous
              les niveaux (
              <strong>
                9<sup>ème</sup> A.F, Bacc (Permanent, Régulier, Bac Unique /
                NS4), École Normale d'Instituteurs (ENI)
              </strong>
              ).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bienvenue;
